import {
  Color,
  ColorsFailure,
  ColorsRepository,
  Either,
  left,
  right,
} from "../../domain";
import { ColorsRemoteDataSourceError } from "../core";
import { ColorsRemoteDataSource } from "../data-sources";

export class ColorsRepositoryImpl implements ColorsRepository {
  constructor(private readonly remoteDataSource: ColorsRemoteDataSource) {}

  private handleError(error: ColorsRemoteDataSourceError): ColorsFailure {
    if (error === "NetworkError") return ColorsFailure.networkFailure();
    return ColorsFailure.serverFailure();
  }

  public async add(
    title: string,
    color: string
  ): Promise<Either<ColorsFailure, null>> {
    try {
      await this.remoteDataSource.add(title, color);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async remove(id: string): Promise<Either<ColorsFailure, null>> {
    try {
      await this.remoteDataSource.remove(id);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async edit(
    id: string,
    info: {
      title?: string;
      color?: string;
    }
  ): Promise<Either<ColorsFailure, null>> {
    try {
      await this.remoteDataSource.edit(id, info);
      return right(null);
    } catch (error) {
      return left(this.handleError(error));
    }
  }

  public async list(): Promise<Either<ColorsFailure, Color[]>> {
    try {
      const res = await this.remoteDataSource.list();
      return right(res);
    } catch (error) {
      return left(this.handleError(error));
    }
  }
}
